import React from "react";
import nursingHomeStore from "@source/store/nursingHomeStore";
import {canManageConsentTemplates} from "@source/utils/consentAccess";
import {TemplateBuilderPage} from "./templateBuilderPage";
import {ConsentRequestState} from "@source/components/consentDocuments";
import ConsentDocumentsLayout from "../consentDocumentsLayout";

export const TemplateEditorPage = () => {
  const organizationId = nursingHomeStore.activeNursingHome?.organization?._id || "";
  return <ConsentDocumentsLayout builder>{organizationId ? <TemplateBuilderPage organizationId={organizationId} canManage={canManageConsentTemplates()}/> : <ConsentRequestState variant="empty" title="Select a nursing home" description="Choose a nursing home with an organization to view form templates."/ >}</ConsentDocumentsLayout>;
};
